const CustomerFundTransferReciept = () => {
  return (
    <>
      <div className=" main-page">
        <div className="container mx-auto">
          <div className="row d-flex justify-content-center">
            <div className=" w-70 mx-auto pt-4">
              <div className="card border-radius-2xl border p-5">
                <div className=" d-flex justify-content-center text-center mb-4">
                  <div>
                    <img
                      src="../../assets/img/salarlogo.png"
                      height="140"
                      alt=""
                    />
                    <div className=" mt-n3 lh-sm">
                      <div>
                        <b className=" text-black fw-bolder text-3xl">
                          Customer Fund Transfer Receipt
                        </b>
                      </div>
                      <div>
                        <b className=" text-black fw-normal">(www.salar.in)</b>
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" d-flex justify-content-between align-items-center text-start pt-4 pb-4 px-4">
                  <div className=" w-100">
                    {" "}
                    <b className="text-black fw-bolder text-md text-start">
                      Date : <b className=" fw-bold text-black">11-10-2025</b>{" "}
                    </b>
                  </div>
                  <div className=" w-100">
                    <b className="text-black fw-bolder text-md text-start">
                      Transaction ID :{" "}
                      <b className=" fw-bold text-black">WR1742878986723</b>{" "}
                    </b>
                  </div>
                  <div className=" w-100 text-end">
                    <b className="text-black fw-bolder text-md text-start">
                      Status : <b className=" fw-bold text-black">Successful</b>{" "}
                    </b>
                  </div>
                </div>
                <div className=" d-flex justify-content-start align-items-start text-start pt-4 pb-4 px-4 gap-6">
                  <div className=" w-80">
                    <div className="mt-2 border-bottom">
                      <h3 className=" fw-bolder text-black">
                        Sender Customer Details
                      </h3>
                    </div>
                    <div className=" pt-3 pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Sender Customer ID :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          S96E863
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Sender Customer Name :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          Suraj Ahmed
                        </b>{" "}
                      </b>
                    </div>
                  </div>
                  <div className=" w-80">
                    <div className="mt-2 border-bottom">
                      <h3 className=" fw-bolder text-black">
                        Beneficiary Customer Details
                      </h3>
                    </div>
                    <div className=" pt-3 pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Beneficiary Customer ID :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          S96E863
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Beneficiary Customer Name :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          Siddharth
                        </b>{" "}
                      </b>
                    </div>
                  </div>
                </div>
                <hr className=" horizontal dark" />
                <div className=" w-100 px-4 pb-3">
                  <div className="mt-2 border-bottom">
                    <h5 className=" fw-bolder text-black">
                      Fund Transfer Details
                    </h5>
                  </div>
                </div>
                <div className=" w-100 px-4 pb-4">
                  <div className="table-responsive">
                    <table className="table text-center  table-bordered align-items-center mb-0">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className=" text-dark text-md font-weight-bolder text-black">
                            Commission Name
                          </th>
                          <th className=" text-dark text-md font-weight-bolder text-black">
                            Fund Transfer Amount
                          </th>
                          <th className=" text-dark text-md font-weight-bolder text-black">
                            Admin Charges
                          </th>
                          <th className=" text-dark text-md font-weight-bolder text-black">
                            Net Fund Transfer Amount
                          </th>
                          <th className=" text-dark text-md font-weight-bolder text-black">
                            Fund Transfer Status
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white">
                        <tr>
                          <td className=" text-dark text-md font-weight-bold">
                            Referral Commission
                          </td>
                          <td className=" text-dark text-md font-weight-bold">
                            <sup>₹</sup>10,000
                          </td>
                          <td className=" text-dark text-md font-weight-bold">
                            <sup>₹</sup>37.665
                          </td>
                          <td className=" text-dark text-md font-weight-bold">
                            <sup>₹</sup>9,962.335
                          </td>
                          <td className=" text-dark text-md font-weight-bold">
                            Successful
                          </td>
                        </tr>
                        <tr></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className=" w-100 px-4 pb-3 text-end">
                  <div className="mt-2">
                    <b className="text-black fw-bolder text-2xl text-start">
                      Total :{" "}
                      <b className=" fw-bold text-black text-capitalize">
                        <sup>₹</sup>715.635
                      </b>{" "}
                    </b>
                  </div>
                </div>
                <div className=" w-100 px-4 pb-3 text-end">
                  <div className="mt-2">
                    <b className="text-black fw-bolder text-2xl text-start">
                      For Sworld Solutions PVT.Ltd :
                    </b>
                  </div>
                  <div className="mt-2">
                    <img src="" alt="" />
                  </div>
                  <div className="mt-2">
                    <b className="text-black fw-bolder text-2xl text-start">
                      Authorized Signatory
                    </b>
                  </div>
                </div>
                <div className=" w-100 px-4 pt-4 text-center">
                  <b className=" text-uppercase fw-bolder text-5xl text-black">
                    Salar
                  </b>
                  <br />
                  <b className=" text-black fw-normal fs-4">
                    If you encounter any issues related to the Payout receipt,
                    you can contact us at
                  </b>
                  <br />
                  <b className="fw-bolder text-2xl text-black">
                    refpayout@salar.in
                  </b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerFundTransferReciept;
